import * as React from 'react';
import { Button, Container, Grid } from '@mui/material';
import { ExtendedTypography } from '../theme';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';


export const NotFound: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Container className={'page'}>
            <ExtendedTypography variant="h2">
                404 - {t('error.headline')}
            </ExtendedTypography>
            <ExtendedTypography variant="highlight">
                Hier geht es zurück zur Startseite.
            </ExtendedTypography>
            <Grid
                container justifyContent="center"
            >
                <Button variant={'contained'} onClick={() => {
                    navigate('/');
                }}>
                    Verstanden
                </Button>
            </Grid>
        </Container>
    );
};
